<template>
  <div class="wrapper">
    <el-header style="background: #F2F2F2;margin-bottom: 30px;margin-bottom: 10px;height: auto!important;min-height: 90px">
      <div style="font-size: 20px;display: flex;justify-content: space-between;padding: 15px 0 5px 0;">
        <span>{{groups.cname}}</span>
        <el-button style="margin-right: 10px" type="primary" @click="synGroupUser()">手动更新</el-button>
      </div>
      <div style="margin: 10px 0;">
        <span style="margin-right: 20px">创建时间：<span>{{groups.createDate}}</span></span>
        <span>更新时间：<span>{{groups.updateDate}}</span></span>
      </div>
    </el-header>
    <FORM  ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/crs36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import download from '@/utils/download'
  import quill from "@/components/page/quill.vue"
  import Qs from 'qs'
  import axios from 'axios'
  let levelType = {"MIN":"迷你","STD":"标准","PLA":"铂金"};
  let activeStatus = {"1": "已激活", "0": "未激活"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    mounted(){
        const data = {groupId:this.$route.query.groupId};
        this.$refs.childTable.defaultQueryData(data);
        this.getGroupInfo();
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if("添加" == clickName){
          this.$refs.childUpdate.open();
        }else if("删除" == clickName){
            console.log(this.deleteIds);
            if (!this.deleteIds && this.deleteIds.length <= 0) {
                this.$message({
                    message: window.$t('txmis.accountReward.choiceOne'),
                    type: 'warning'
                });
                return false;
            }
            this.$axios.get(URL.ceGroup.userDel, {
                params:{ids:this.deleteIds}
            }).then((res)=>{
                if (res.code == 0) {
                    this.$message.success("成功");
                }else{
                    this.$message.success("失败");
                }
            }).catch(function (error) {
                this.$message.success("失败");
                console.log(error);
            });
        }else if("导出" == clickName){
            download.exportExcel(URL.ceGroup.userExport,data,this.groups.cname);
        }
      },
      async getGroupInfo(){
          await this.$axios.post(URL.ceGroup.get, Qs.stringify({id: this.$route.query.groupId})).then((res) => {
              if (res.code == 0) {
                  this.groups=res.result;
              }
          }).catch(function (error) {
              console.log(error);
          });
      },
      synGroupUser(){
          this.$axios.post(URL.ceGroup.synGroupUserList, Qs.stringify({groupId: this.$route.query.groupId})).then((res) => {
              if (res.code == 0) {
                  this.$router.go(0);
                  this.$message.success("同步成功");
              } else {
                  this.$message.error(res.message);
              }
          }).catch(function (error) {
              console.log(error);
          });
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.ceGroup.userSave,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
          this.$refs.childTable.defaultGetData(this.queryData);
        }else{
            this.$message.error(window.$t('txmis.rewardDealList.confirmFail'));
        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        groups:{},
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                          { title: '用户账号', field: 'customerNo'},
                      ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: '用户账号', field: 'customerNo'},
                          { title: '姓名', field: 'chineseName'},
                          { title: '手机号', field: 'phone'},
                          { title: '账号等级', field: 'userLevel'},
                          { title: '激活状态', field: 'activateDate'},
                          { title: window.$t('txmis.tracker.openStartTime'), field: 'startOpenTime',data:this.start,type:5},
                          { title: window.$t('txmis.tracker.openEndTime'), field: 'endOpenTime',data:this.end,type:5},
                          { title: window.$t('txmis.tracker.activeStartTime'), field: 'startActiveTime',type:5},
                          { title: window.$t('txmis.tracker.activeEndTime'), field: 'endActiveTime',type:5},
                          { title: window.$t('txmis.tracker.utmSource'), field: 'utmSource'},
                          { title: window.$t('txmis.tracker.utmMedium'), field: 'utmMedium'},
                          { title: window.$t('txmis.tracker.utmCampaign'), field: 'utmCampaign'},
                          {click:"查询"},
              {click:"添加"},
              {click:"导出"},
              {click:"删除"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.ceGroup.userList, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: '账号', field: 'customerNo'},
                          { title: '姓名', field: 'chineseName'},
                          { title: '手机号', field: 'phone'},
                          { title: '账号级别', field: 'userLevel'},
                          {
                              title: window.$t('txmis.relationList.activeStatus'), field: 'activeTime', render: (data, full) => {
                                  if (full.activeTime > 0) {
                                      return "已激活";
                                  } else {
                                      return "未激活";
                                  }
                              }
                          },
                          { title: '开户时间', field: 'openDate',render:(data)=>{
                                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                              }},
                          { title: '激活时间', field: 'activateDate',render:(data)=>{
                                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                          }}
          ]
        }
      }
    }
  }
</script>
